module.exports = __webpack_public_path__ + "static/media/step_detail_career_thuong_mai_mobile.241fd478.jpg";